export default __webpack_public_path__ + "static/media/ferocioussmack5.48017d15.png";